<template>
  <div class="config-content content" v-if="config.content">
    <el-link type="danger" :underline="false">现场拜访注意事项</el-link>
    <div v-html="config.content" class="mt-10"></div>
  </div>
</template>

<script>
import { getCustomConfig } from '@/service/getData'
export default {
  props: {
    customerid: Number,
  },
  data() {
    return {
      config: '',
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await getCustomConfig({ type: 1, customer_id: this.customerid })
      if (res.data.id) {
        this.config = res.data
      }
    },
  },
}
</script>

<style scoped>
.config-content {
  width: 350px;
  position: absolute;
  top: 0;
  right: -355px;
  white-space: pre-line;
}
.content {
  padding: 16px 16px;
  background-color: #fff6f7;
  border-radius: 4px;
  border-left: 5px solid #fe6c6f;
}
</style>